var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Card, Col, Divider, Row, Spin, Statistic } from "antd";
import React, { useEffect, useState } from "react";
import { i18n } from "../../../../translations";
import { GroupAnalyticsNewTKeys } from "../../../../translations/keys";
import Chart from "react-apexcharts";
var ViolationsStatisticsCard = function (props) {
    var colors = ["#ff3f34", "#e6392f", "#cc322a", "#b32c24", "#99261f"];
    var _a = __read(useState([]), 2), pieData4 = _a[0], setPieData4 = _a[1];
    var _b = __read(useState(), 2), analyticsData = _b[0], setAnalyticsData = _b[1];
    var _c = __read(useState(true), 2), loading = _c[0], setLoading = _c[1];
    useEffect(function () {
        setLoading(props.loading);
    }, [props.loading]);
    useEffect(function () {
        setLoading(true);
        setAnalyticsData(props.data);
        setLoading(false);
    }, [props.data]);
    useEffect(function () {
        setLoading(true);
        setPieData4(props.graphData);
        setLoading(false);
    }, [props.graphData]);
    return (React.createElement(Col, { span: 24 },
        React.createElement(Spin, { spinning: loading },
            React.createElement(Card, { headStyle: { fontSize: '16px' }, title: React.createElement(React.Fragment, null, i18n.t(GroupAnalyticsNewTKeys.violationStatistics)) },
                React.createElement(Row, null,
                    React.createElement(Col, { span: 4 },
                        React.createElement("div", { className: "big-metric" },
                            React.createElement(Statistic, { style: {
                                    flexDirection: "column-reverse",
                                    display: "flex",
                                }, title: React.createElement(React.Fragment, null,
                                    React.createElement(Divider, { style: { margin: "12px 0px" } }),
                                    i18n.t(GroupAnalyticsNewTKeys.totalNumberOfViolations)), value: analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.total_violations, valueStyle: { fontSize: "3vw" } }))),
                    React.createElement(Col, { span: 18, offset: 1 },
                        React.createElement("h2", { style: { fontWeight: 700, fontSize: 16 } }, i18n.t(GroupAnalyticsNewTKeys.bottom5ByNumberOfViolations)),
                        React.createElement("div", { style: { height: 160 } },
                            React.createElement(Chart, { options: {
                                    chart: {
                                        type: 'bar',
                                        height: 200,
                                    },
                                    dataLabels: {
                                        enabled: false
                                    },
                                    legend: {
                                        show: false
                                    },
                                    plotOptions: {
                                        bar: {
                                            horizontal: true,
                                            distributed: true,
                                        },
                                    },
                                    xaxis: {
                                        categories: pieData4.map(function (x) { return x.x; }),
                                    },
                                    yaxis: {
                                        title: {
                                            text: undefined
                                        },
                                    },
                                    fill: {
                                        opacity: 1,
                                    },
                                }, series: [{
                                        data: pieData4.map(function (x) { return x.y; })
                                    }], type: "bar", height: 200 }))))))));
};
export default ViolationsStatisticsCard;
